/*jslint browser: true, fudge: true, long: true, for: true */
/*global HTMLMediaElement, blacksunplc, console, document, history, parseFloat, setTimeout, window, console */

/**
 * A module providing utility related functions.
 * @module blacksunplc/utils
 * @requires blacksunplc/objects
 * @requires blacksunplc/security
 */

var bsComponents = {};
(function () {
    "use strict";

    var freeze = blacksunplc.objects.freeze;          // import {freeze}     from "module:blacksunplc/objects"
    var arrays = blacksunplc.arrays;                  // import * as arrays    from "module:blacksunplc/arrays"
    var $$ = blacksunplc.nodes.qsa;                   // import {qsa as $$}   from "module:blacksunplc/nodes"

    var exports = {};

    /**
     * Determines if the primary interaction device is mouse-like.
     * <p>The result value will always be <code>true</code> on older devices that
     * do not support either `matchMedia` or CSS Media Queries Level 4.</p>
     * @return {boolean}
     * @see https://developer.mozilla.org/en-US/docs/Web/CSS/Media_Queries/Using_media_queries#Media_features
     * @see https://caniuse.com/#feat=css-media-interaction
     */
    exports.isPrimaryInteractionMouseLike = function () {
        return !(window.matchMedia && (
            window.matchMedia("(hover: none)").matches ||
            window.matchMedia("(pointer: none)").matches ||
            window.matchMedia("(pointer: coarse)").matches
        ));
    };


    /**
     * @enum {number}
     * @see https://www.w3.org/TR/uievents/#fixed-virtual-key-codes
     */
    var KeyCode = {
        BACKSPACE: 8,
        TAB: 9,
        ENTER: 13,
        SHIFT: 16,
        CONTROL: 17,
        ALT: 18,
        CAPSLOCK: 20,
        ESCAPE: 27,
        SPACE: 32,
        PAGEUP: 33,
        PAGEDOWN: 34,
        END: 35,
        HOME: 36,
        ARROWLEFT: 37,
        ARROWUP: 38,
        ARROWRIGHT: 39,
        ARROWDOWN: 40,
        DELETE: 46
    };

    /**
     * @param {!Event} event
     * @param {!HTMLUListElement} component
     * @param {string} element
     * @param {string} className
     */
    exports.commonKeyDown = function (event, component, element, className) {
        var allLinks = $$(element, component);
        if (!className) {
            className = "selected";
        }

        var activeIndex = arrays.findIndex($$(element, component), function (anchorTag) {
            return anchorTag.classList.contains(className);
        });

        var firstChild = allLinks[0];
        var lastChild = allLinks[allLinks.length - 1];
        var prevSibling = allLinks[activeIndex - 1];
        var nextSibling = allLinks[activeIndex + 1];

        if (!prevSibling) {
            prevSibling = lastChild;
        }
        if (!nextSibling) {
            nextSibling = firstChild;
        }

        /**
         * @param {!Element} targetElement
         */
        function clickElement(targetElement) {
            targetElement.focus();
            targetElement.click();
        }
        switch (event.keyCode) {
            case KeyCode.ARROWRIGHT:
            case KeyCode.ARROWDOWN:
                event.preventDefault();
                clickElement(nextSibling);
                break;
            case KeyCode.ARROWLEFT:
            case KeyCode.ARROWUP:
                event.preventDefault();
                clickElement(prevSibling);
                break;
            case KeyCode.HOME:
                event.preventDefault();
                clickElement(firstChild);
                break;
            case KeyCode.END:
                event.preventDefault();
                clickElement(lastChild);
                break;
            case KeyCode.SPACE:
                event.preventDefault();
                break;
            default:
                return;
        }
    }

    bsComponents.utils = freeze(exports);
}());
